var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"logo"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})]),_c('div',[_vm._v(_vm._s(_vm.title))])])]),_c('nav-menu'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('img',{attrs:{"src":require("@/assets/images/mascot.png"),"alt":""}})])
}]

export { render, staticRenderFns }